import React from 'react';
import Login from '../pages/auth/login/Login';
import Signup from '../pages/auth/signup/Signup';
import ForgotPassword from '../pages/auth/forgot-password/ForgotPassword';
import ResetPassword from '../pages/auth/reset-password/ResetPassword';
import SetNewPassword from '../pages/auth/set-new-password/SetNewPassword';
import Dashboard from '../pages/dashboard/Dashboard';
import FiatTransactions from '../pages/transactions/FiatTransactions';
import ProjectDetails from '../pages/projects/ProjectDetails';
import ProjectList from '../pages/projects/ProjectList';
import OwnedAssets from '../pages/projects/OwnedAssets';
import ProjectAgreement from '../pages/agreement/ProjectAgreement';
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import Profile from '../pages/user/Profile';
import PageNotFound from '../components/common/PageNotFound';
/*
Note: Dont use statis routes for appBaseEndpoint and fallbackEndpoint, import below variables instead wherever necessary in the pages
*/
/* 
path: Path of the endpoint
component: Pass the component which you want to render on given path
isGaurded: Set to true if want the page protected or else pass false
redirectTo (optional): Pass the desired path where you want to redirect when the path matches with the active path
*/
export const mainRoutes = [
  {
    path: '/',
    element: <Dashboard />,
    isGuarded: true,
  },
  {
    path: '/signup',
    element: <Signup />,
    isGuarded: false,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
    isGuarded: false,
  },
  {
    path: '/reset-password/:token',
    element: <ResetPassword />,
    isGuarded: false,
  },
  {
    path: '/set-new-password/:token',
    element: <SetNewPassword />,
    isGuarded: false,
  },
  {
    path: '/set-new-password-social/:token',
    element: <SetNewPassword />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
    isGuarded: true,
  },
  {
    path: '/transactions/fiat',
    element: <FiatTransactions />,
    isGuarded: true,
  },
  {
    path: '/assets',
    element: <ProjectList />,
    isGuarded: true,
  },
  {
    path: '/assets/details/:id',
    element: <ProjectDetails />,
    isGuarded: true,
  },
  {
    path: '/assets/payment/checkout/:id/:orderId',
    element: <ProjectDetails />,
    isGuarded: true,
  },
  {
    path: '/owned-assets/details/:id',
    element: <ProjectDetails />,
    isGuarded: true,
  },
  {
    path: '/owned-assets',
    element: <OwnedAssets />,
    isGuarded: true,
  },
  {
    path: '/asset/signed-agreement',
    element: <ProjectAgreement />,
    isGuarded: true,
  },
  {
    path: '/linkedin-call-back',
    element: <LinkedInCallback />,
    isGuarded: false,
  },
  {
    path: '/profile',
    element: <Profile />,
    isGuarded: true,
  },
  {
    path: '*',
    element: <PageNotFound />,
    isGuarded: true,
  },
];
